export default __webpack_public_path__ + "static/media/question-img-1.ba56a623.png";